'use client';

import classnames from 'classnames';

import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import HorizontalCard from 'components/Switchbacks/TextWithBackgroundImage/HorizontalCard';
import styles from 'components/Switchbacks/TextWithBackgroundImage/text-w-background-image.module.scss';

import type { TextWithBackGroundImageSwitchback } from 'components/Switchbacks/TextWithBackgroundImage/config';
import type { FC } from 'react';

const TextWithBackgroundImage: FC<TextWithBackGroundImageSwitchback> = ({
  backgroundColor,
  backgroundSize,
  backgroundImage,
  contentAlignment,
  heading,
  body,
  card,
  foregroundImage,
}) => {
  const wrapperClass = classnames(styles.wrapper, {
    [styles.bkgBlue]: backgroundColor === 'blue',
    [styles.bkgGray]: backgroundColor === 'gray',
    [styles.bkgTeal]: backgroundColor === 'teal',
  });
  const alignmentClass = {
    [styles.right]: contentAlignment === 'right',
  };
  const backgroundClass = {
    [styles.backgroundLarge]: backgroundSize === 'large',
  };

  return (
    <section
      className={classnames(wrapperClass, alignmentClass, backgroundClass)}
      style={{ backgroundImage: backgroundImage ? `url(${backgroundImage.url})` : undefined }}
    >
      <article className={classnames(styles.container, alignmentClass)}>
        <div className={styles.content}>
          {heading && <h2 className="heading3">{heading}</h2>}
          {body && <RichText content={body} />}
          {card?.cardTitle && (
            <HorizontalCard
              classes={{
                heading: styles.cardHeading,
                content: styles.cardContent,
              }}
              heading={card?.cardTitle}
              content={card?.cardContent || ''}
              image={card?.cardImage}
            />
          )}
        </div>
        {foregroundImage?.url && (
          <div className={styles.imageContainer}>
            <div style={{ width: foregroundImage?.width || 0, height: foregroundImage?.height || 0 }} />
            <Image
              url={foregroundImage?.url}
              alt={foregroundImage?.alt || ''}
              fill
              sizes="100%"
              style={{ maxWidth: `${foregroundImage?.width}px` }}
              quality={100}
            />
          </div>
        )}
      </article>
    </section>
  );
};

export default TextWithBackgroundImage;
